import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import React from 'react';
import { useStyles as useNavListStyles } from '@dev-togetherprice/components.nav-list';
import VerticalCentered from '@dev-togetherprice/components.vertical-centered';
import { useStyles as useSidebarStyles } from './Sidebar';
const SidebarSkeleton = ({ showSidebar = false }) => {
    const classes = useSidebarStyles({ showSidebar });
    const navClasses = useNavListStyles({ collapsed: showSidebar });
    return (React.createElement(Grid, { item: true, xs: 12, className: clsx(classes.sidebar, {
            [classes.sidebarClosed]: !showSidebar,
        }) },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { item: true },
                React.createElement(VerticalCentered, null,
                    React.createElement(Skeleton, { variant: 'circle', width: showSidebar ? '100px' : '50px', height: showSidebar ? '100px' : '50px' })),
                showSidebar && (React.createElement(VerticalCentered, null,
                    React.createElement(Skeleton, { variant: 'rect', width: showSidebar ? '150px' : '40px', height: '40px', className: classes.fullName })))),
            React.createElement(Grid, { className: classes.links }, Array.from(Array(5).keys()).map((key) => (React.createElement(Grid, { key: `${key}-grid`, item: true, xs: 12, className: navClasses.itemWrapper },
                React.createElement(Skeleton, { key: `${key}-skeleton`, variant: 'rect', width: '100%', height: '50px' }))))))));
};
export default SidebarSkeleton;
